/**
 * Formats orderSubNr to always be 3 digits with leading zeros
 * @param orderSubNr - The order sub number (e.g., 1, 12, 123)
 * @returns Formatted string with leading zeros (e.g., "001", "012", "123")
 */
export function formatOrderSubNr(orderSubNr: number | string): string {
  return String(orderSubNr).padStart(3, '0');
}
